import styled, { css } from 'styled-components';

import { BadgeColor } from 'types';

export const Container = styled.span`
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`;

export const Text = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Same size and tokens as the badge dot (components/badge Dot).
export const Dot = styled.i<{ $color: BadgeColor }>`
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  border-radius: 50%;

  ${({ theme, $color }) => {
    const config = theme.config.badge[$color];
    return (
      'dot' in config &&
      css`
        background-color: ${config.dot};
      `
    );
  }}
`;
